import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable } from 'rxjs';
import { Parking } from '../models/parking.model';

@Injectable({
  providedIn: 'root',
})
export class ParkingService {
  private apiService = inject(ApiService);

  getUser(username: string) {
    return this.apiService.getById('', username);
  }

  getAssignmentParking(data: any): Observable<Parking[]> {
    return this.apiService.getById('', data);
  }

  storeAssignmentParking(data: any) {
    return this.apiService.store('', data);
  }

  deleteAssignmentParking(id: number) {
    return this.apiService.delete('', id);
  }

  agetWithParking(businessId: number) {
    const url = `/worker/WithParking?businessId=${businessId}`;
    return this.apiService.get(url);
  }

  getWithParking(businessId: any) {
    return this.apiService.getAll(
      `worker/WithParking?businessId=${businessId}`
    );
  }
}
